// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar gradient and styling */
.sidebar-gradient {
  background: linear-gradient(
    to bottom,
    #5a00d8 0%,
    #5a00d8 33%,
    #7e42df 90%,
    #8e5ce5 100%
  );
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* Agent items in sidebar */
.agent-item {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.agent-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.agent-item.active {
  background-color: #3e009b;
}

.agent-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
  border-radius: 50%;
}

.agent-name {
  color: white;
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* User profile section at the bottom */
.user-profile-container {
  margin-top: auto;
  padding: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}

.user-profile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.user-info {
  display: flex;
  align-items: center;
}

.user-avatar {
  background-color: #3e009b !important;
  margin-right: 10px;
}

.username {
  color: white;
  font-weight: bold;
  font-size: 15px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Collapsed state styles */
.collapsed-user-profile {
  padding: 16px 0;
  display: flex;
  justify-content: center;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}

/* Input tabs styling */
.agent-tabs {
  display: flex;
  align-items: flex-end;
  padding-left: 16px;
  height: 40px;
  margin-bottom: 16px;
}

.agent-tab {
  padding: 0 8px;
  height: 32px;
  display: flex;
  align-items: center;
  background: #d1b1ff;
  color: #6200EE;
  cursor: pointer;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  margin-right: 4px;
  transition: all 0.3s;
}

.agent-tab.active {
  background: white;
  font-weight: bold;
  border: 1px solid #d1b1ff;
  border-bottom: none;
}

/* Custom styles for the collapse component */
.custom-collapse .ant-collapse-header {
  background-color: white !important;
  border-radius: 4px 4px 0 0 !important;
  font-size: 18px !important;
  font-weight: bold !important;
  padding: 12px 16px !important;
}

.ant-collapse {
  background-color: white !important;
}

.ant-collapse-content {
  background-color: white !important;
}

/* Button styles */
.detail-button, .nav-button, .custom-button {
  background-color: #d1b1ff !important;
  border-color: #c29fee !important;
  color: #4d2c91 !important;
  font-weight: bold !important;
}

.detail-button:hover, .nav-button:hover, .custom-button:hover {
  background-color: #c29fee !important;
  border-color: #b78dec !important;
}

/* Submit button */
.submit-button {
  background-color: #6200EE !important;
  border-color: #5000c4 !important;
  color: white !important;
  font-weight: bold !important;
}

.submit-button:hover {
  background-color: #5000c4 !important;
}

/* Drag and drop styles */
.draggable-component {
  cursor: move;
  transition: opacity 0.2s ease;
}

.draggable-component:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.drop-column {
  min-height: 100px;
  height: 100%;
  border: 1px dashed #ccc;
  border-radius: 4px;
  background: #f9f9f9;
  padding: 8px;
  transition: background-color 0.2s ease;
}

.drop-column-hover {
  background-color: rgba(209, 177, 255, 0.2);
}


/* For Webkit browsers (Chrome, Safari) */
::-webkit-scrollbar {
  width: 8px; /* Reduce from default */
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(241, 241, 241, 0.5); 
}

::-webkit-scrollbar-thumb {
  background: #c4c4c4; 
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8; 
}

/* For Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: #c4c4c4 rgba(241, 241, 241, 0.5);
}

/* Specifically target the chat message container to ensure slim scrollbars */
.markdown-content {
  overflow-x: auto;
  scrollbar-width: thin;
}

.markdown-content::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.ant-notification {
  z-index: 9999 !important;
}

.ant-notification-notice {
  z-index: 9999 !important;
}

.custom-notification {
  z-index: 9999 !important;
}

/* Ensure no parent containers are hiding notifications */
.ant-layout {
  overflow: visible !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE;;;;;;GAMC;EACD,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,aAAa;EACb,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,kCAAkC;EAClC,qCAAqC;EACrC,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;;AAGA,yCAAyC;AACzC;EACE,UAAU,EAAE,wBAAwB;EACpC,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA,6EAA6E;AAC7E;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yDAAyD;AACzD;EACE,4BAA4B;AAC9B","sourcesContent":["/* Sidebar gradient and styling */\n.sidebar-gradient {\n  background: linear-gradient(\n    to bottom,\n    #5a00d8 0%,\n    #5a00d8 33%,\n    #7e42df 90%,\n    #8e5ce5 100%\n  );\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n/* Agent items in sidebar */\n.agent-item {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 10px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.agent-item:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.agent-item.active {\n  background-color: #3e009b;\n}\n\n.agent-icon {\n  width: 24px;\n  height: 24px;\n  margin-right: 12px;\n  border-radius: 50%;\n}\n\n.agent-name {\n  color: white;\n  font-size: 16px;\n  font-weight: bold;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* User profile section at the bottom */\n.user-profile-container {\n  margin-top: auto;\n  padding: 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.3);\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.user-profile {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n}\n\n.user-avatar {\n  background-color: #3e009b !important;\n  margin-right: 10px;\n}\n\n.username {\n  color: white;\n  font-weight: bold;\n  font-size: 15px;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Collapsed state styles */\n.collapsed-user-profile {\n  padding: 16px 0;\n  display: flex;\n  justify-content: center;\n  border-top: 1px solid rgba(255, 255, 255, 0.3);\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n/* Input tabs styling */\n.agent-tabs {\n  display: flex;\n  align-items: flex-end;\n  padding-left: 16px;\n  height: 40px;\n  margin-bottom: 16px;\n}\n\n.agent-tab {\n  padding: 0 8px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  background: #d1b1ff;\n  color: #6200EE;\n  cursor: pointer;\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n  margin-right: 4px;\n  transition: all 0.3s;\n}\n\n.agent-tab.active {\n  background: white;\n  font-weight: bold;\n  border: 1px solid #d1b1ff;\n  border-bottom: none;\n}\n\n/* Custom styles for the collapse component */\n.custom-collapse .ant-collapse-header {\n  background-color: white !important;\n  border-radius: 4px 4px 0 0 !important;\n  font-size: 18px !important;\n  font-weight: bold !important;\n  padding: 12px 16px !important;\n}\n\n.ant-collapse {\n  background-color: white !important;\n}\n\n.ant-collapse-content {\n  background-color: white !important;\n}\n\n/* Button styles */\n.detail-button, .nav-button, .custom-button {\n  background-color: #d1b1ff !important;\n  border-color: #c29fee !important;\n  color: #4d2c91 !important;\n  font-weight: bold !important;\n}\n\n.detail-button:hover, .nav-button:hover, .custom-button:hover {\n  background-color: #c29fee !important;\n  border-color: #b78dec !important;\n}\n\n/* Submit button */\n.submit-button {\n  background-color: #6200EE !important;\n  border-color: #5000c4 !important;\n  color: white !important;\n  font-weight: bold !important;\n}\n\n.submit-button:hover {\n  background-color: #5000c4 !important;\n}\n\n/* Drag and drop styles */\n.draggable-component {\n  cursor: move;\n  transition: opacity 0.2s ease;\n}\n\n.draggable-component:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.drop-column {\n  min-height: 100px;\n  height: 100%;\n  border: 1px dashed #ccc;\n  border-radius: 4px;\n  background: #f9f9f9;\n  padding: 8px;\n  transition: background-color 0.2s ease;\n}\n\n.drop-column-hover {\n  background-color: rgba(209, 177, 255, 0.2);\n}\n\n\n/* For Webkit browsers (Chrome, Safari) */\n::-webkit-scrollbar {\n  width: 8px; /* Reduce from default */\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: rgba(241, 241, 241, 0.5); \n}\n\n::-webkit-scrollbar-thumb {\n  background: #c4c4c4; \n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8; \n}\n\n/* For Firefox */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #c4c4c4 rgba(241, 241, 241, 0.5);\n}\n\n/* Specifically target the chat message container to ensure slim scrollbars */\n.markdown-content {\n  overflow-x: auto;\n  scrollbar-width: thin;\n}\n\n.markdown-content::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.ant-notification {\n  z-index: 9999 !important;\n}\n\n.ant-notification-notice {\n  z-index: 9999 !important;\n}\n\n.custom-notification {\n  z-index: 9999 !important;\n}\n\n/* Ensure no parent containers are hiding notifications */\n.ant-layout {\n  overflow: visible !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
